import 'core-js/modules/es.object.assign.js';
import { __awaiter } from '../../../../_virtual/_tslib.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { useUtility, Stack, Text, Box, Button } from '@hub-la/design-system';
import { GetAssetSize, AssetStatus } from '@hub-la/fe-asset';
import { AttachFile } from '@mui/icons-material';
import FilePresentIcon from '@mui/icons-material/FilePresent';
import { useTranslation } from 'react-i18next';
import { HumanFileSize } from '../../../usecases/human-file-size.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'react';
import { useSaveFile } from '../../hooks/use-save-file.js';
import '@hub-la/fe-container';
import '@hub-la/fe-core-http-client';
import 'react-query';
import '../../../domain/dtos/query-key.js';
import '../../../usecases/save-post.js';

const PostAttachmentView = ({
  assets
}) => {
  const {
    t
  } = useTranslation();
  const {
    palette
  } = useUtility();
  const saveFile = useSaveFile();
  const downloadAsset = asset => __awaiter(void 0, void 0, void 0, function* () {
    yield saveFile.mutateAsync({
      asset
    });
  });
  return jsx(Stack, Object.assign({
    flexDirection: "row",
    alignContent: "space-between",
    my: 2,
    style: {
      overflowX: 'scroll',
      scrollSnapType: 'x mandatory'
    }
  }, {
    children: assets.map((asset, index) => {
      var _a, _b;
      const assetSize = new GetAssetSize().execute(asset);
      const isProcessing = asset.status === AssetStatus.processing || asset.status === AssetStatus.uploading;
      const hasError = asset.status === AssetStatus.error;
      const isDownloading = saveFile.isLoading && ((_b = (_a = saveFile.variables) === null || _a === void 0 ? void 0 : _a.asset) === null || _b === void 0 ? void 0 : _b.id) === (asset === null || asset === void 0 ? void 0 : asset.id);
      return jsx(Stack, Object.assign({
        marginLeft: index === 0 ? 0 : 2,
        style: {
          scrollSnapAlign: 'start'
        }
      }, {
        children: jsxs(Stack, Object.assign({
          bgcolor: palette('surface'),
          padding: 4,
          borderRadius: 1,
          minHeight: "174px",
          width: "156px",
          style: {
            overflowWrap: 'anywhere'
          },
          height: "100%",
          justifyContent: "space-between"
        }, {
          children: [jsx(Text, Object.assign({
            variant: "body1",
            fontWeight: 600
          }, {
            children: asset.name
          })), isProcessing && jsx(Text, Object.assign({
            variant: "body2",
            color: "outline"
          }, {
            children: t('assets.processing')
          })), hasError && jsx(Text, Object.assign({
            variant: "body2",
            color: "outline"
          }, {
            children: t('assets.error')
          })), jsxs(Box, Object.assign({
            mt: 3
          }, {
            children: [jsx(Stack, Object.assign({
              direction: "row",
              mt: 2,
              flex: 1
            }, {
              children: assetSize !== 0 && jsxs(Fragment, {
                children: [jsx(FilePresentIcon, {
                  sx: {
                    color: palette('neutralPrimary')
                  }
                }), jsx(Text, Object.assign({
                  variant: "body2",
                  color: "neutralPrimary"
                }, {
                  children: new HumanFileSize().execute(assetSize, true, 0)
                }))]
              })
            })), jsx(Button, Object.assign({
              fullWidth: true,
              marginTop: 2,
              startIcon: jsx(AttachFile, {}),
              onClick: () => downloadAsset(asset),
              variant: "outlined",
              loading: isDownloading || isProcessing,
              disabled: hasError,
              "data-testid": "download-btn"
            }, {
              children: t('postDetail.assets.download')
            }))]
          }))]
        }))
      }), index);
    })
  }));
};

export { PostAttachmentView };
